import React from 'react';

import { useRouteError } from 'react-router-dom';

import { ErrorFallback } from './ErrorFallback';

export const RouteErrorFallback: React.FC = () => {
  const error = useRouteError() as Error;

  const handleRetry = () => {
    window.location.reload();
  };

  return <ErrorFallback error={error} resetErrorBoundary={handleRetry} />;
};
